/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { historyControllerCreateV1 } from '../fn/history/history-controller-create-v-1';
import { HistoryControllerCreateV1$Params } from '../fn/history/history-controller-create-v-1';
import { historyControllerDeleteV1 } from '../fn/history/history-controller-delete-v-1';
import { HistoryControllerDeleteV1$Params } from '../fn/history/history-controller-delete-v-1';
import { historyControllerFindAllV1 } from '../fn/history/history-controller-find-all-v-1';
import { HistoryControllerFindAllV1$Params } from '../fn/history/history-controller-find-all-v-1';
import { historyControllerFindByIdV1 } from '../fn/history/history-controller-find-by-id-v-1';
import { HistoryControllerFindByIdV1$Params } from '../fn/history/history-controller-find-by-id-v-1';
import { historyControllerReorderV1 } from '../fn/history/history-controller-reorder-v-1';
import { HistoryControllerReorderV1$Params } from '../fn/history/history-controller-reorder-v-1';
import { historyControllerSearchV1 } from '../fn/history/history-controller-search-v-1';
import { HistoryControllerSearchV1$Params } from '../fn/history/history-controller-search-v-1';
import { historyControllerToggleExposedV1 } from '../fn/history/history-controller-toggle-exposed-v-1';
import { HistoryControllerToggleExposedV1$Params } from '../fn/history/history-controller-toggle-exposed-v-1';
import { historyControllerUpdateV1 } from '../fn/history/history-controller-update-v-1';
import { HistoryControllerUpdateV1$Params } from '../fn/history/history-controller-update-v-1';
import { HistoryDto } from '../models/history-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class HistoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `historyControllerSearchV1()` */
  static readonly HistoryControllerSearchV1Path = '/api/v1/history/search';

  /**
   * History 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerSearchV1$Response(params?: HistoryControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<HistoryDto>;
}>> {
    return historyControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerSearchV1(params?: HistoryControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<HistoryDto>;
}> {
    return this.historyControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<HistoryDto>;
}>): OffsetPaginationDto & {
'items'?: Array<HistoryDto>;
} => r.body)
    );
  }

  /** Path part for operation `historyControllerFindAllV1()` */
  static readonly HistoryControllerFindAllV1Path = '/api/v1/history';

  /**
   * 모든 History 목록 조회 (노출된 것만).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerFindAllV1$Response(params?: HistoryControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
    return historyControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 History 목록 조회 (노출된 것만).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerFindAllV1(params?: HistoryControllerFindAllV1$Params, context?: HttpContext): Observable<Array<HistoryDto>> {
    return this.historyControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HistoryDto>>): Array<HistoryDto> => r.body)
    );
  }

  /** Path part for operation `historyControllerCreateV1()` */
  static readonly HistoryControllerCreateV1Path = '/api/v1/history';

  /**
   * History 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerCreateV1$Response(params: HistoryControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    return historyControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerCreateV1(params: HistoryControllerCreateV1$Params, context?: HttpContext): Observable<HistoryDto> {
    return this.historyControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyControllerFindByIdV1()` */
  static readonly HistoryControllerFindByIdV1Path = '/api/v1/history/{id}';

  /**
   * History id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerFindByIdV1$Response(params: HistoryControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    return historyControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerFindByIdV1(params: HistoryControllerFindByIdV1$Params, context?: HttpContext): Observable<HistoryDto> {
    return this.historyControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyControllerDeleteV1()` */
  static readonly HistoryControllerDeleteV1Path = '/api/v1/history/{id}';

  /**
   * History 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerDeleteV1$Response(params: HistoryControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return historyControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerDeleteV1(params: HistoryControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.historyControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `historyControllerUpdateV1()` */
  static readonly HistoryControllerUpdateV1Path = '/api/v1/history/{id}';

  /**
   * History 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerUpdateV1$Response(params: HistoryControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    return historyControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerUpdateV1(params: HistoryControllerUpdateV1$Params, context?: HttpContext): Observable<HistoryDto> {
    return this.historyControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

  /** Path part for operation `historyControllerReorderV1()` */
  static readonly HistoryControllerReorderV1Path = '/api/v1/history/reorder';

  /**
   * 연혁 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerReorderV1$Response(params: HistoryControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return historyControllerReorderV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 연혁 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  historyControllerReorderV1(params: HistoryControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    return this.historyControllerReorderV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `historyControllerToggleExposedV1()` */
  static readonly HistoryControllerToggleExposedV1Path = '/api/v1/history/{id}/toggle-exposed';

  /**
   * History 노출 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerToggleExposedV1$Response(params: HistoryControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HistoryDto>> {
    return historyControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * History 노출 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyControllerToggleExposedV1(params: HistoryControllerToggleExposedV1$Params, context?: HttpContext): Observable<HistoryDto> {
    return this.historyControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HistoryDto>): HistoryDto => r.body)
    );
  }

}
